import { BaseGridRenderer } from './base-grid-renderer';
import { MeshJsonData } from '../../models/element-types';

export class MeshRenderer extends BaseGridRenderer<MeshJsonData> {
    protected get defaultData(): MeshJsonData {
        return {
            id: '',
            type: 'mesh'
        };
    }

    protected renderElement(meshJsonData: MeshJsonData): HTMLElement {
        const element = document.createElement('div');
        element.id = meshJsonData.id;
        element.dataset['mesh'] = '';

        const container = document.createElement('div');
        container.dataset['meshContainer'] = '';
        container.classList.add('mesh-container');
        element.appendChild(container);

        return element;
    }
}
